import { render, staticRenderFns } from "./TaskDetailsPRT.vue?vue&type=template&id=708af0b3&scoped=true"
import script from "./TaskDetailsPRT.vue?vue&type=script&lang=js"
export * from "./TaskDetailsPRT.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailsPRT.vue?vue&type=style&index=0&id=708af0b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708af0b3",
  null
  
)

export default component.exports